<template>
  <div>
    <startVideo :videoURL="urlVideo" @closeModal="showVideo = false" :dateTilte="dateTest" :isShow="showVideo" />


    <div class="card mb-0" style="min-height: 50vh !important">
      <Loader :loading="loader">
        <div class="d-flex justify-content-between mb-2">
          <b-button :disabled="activeExport()" :class="{
            'bg-disabled': activeExport(),
          }" class="btn-lyg float-end w-lg mt-lg-n2" @click="doAction()" style="padding: 5px; font-size: 14px;">
            Excel出力
          </b-button>
          <h5 class="card-title mb-3">
          </h5>
          <div>
          </div>
        </div>

        <div class="col-12">
          <b-table :items="gRangerOfMotion || []" :fields="fields" hover outlined
            thead-class=" text-center bg-table-lyg" sticky-header responsive="sm"
            :style="{ maxHeight: isExpand ? '66vh' : '38vh' }">
            <template #head(#)>
              <b-form-checkbox id="checkbox-all" @change="checkAll()" name="checkbox-all" :checked="isCheckedAll()">
              </b-form-checkbox>
            </template>

            <template #cell(#)="row">
              <b-form-checkbox id="checkbox-1" @change="chooseItem(row.item.id)" name="checkbox-1"
                :checked="isChecked(row.item.id)">
              </b-form-checkbox>
            </template>

            <template #cell(patientId)="row">
              {{ row.item.user.patient_id }}
            </template>
            <template #cell(fullName)="row">
              {{ row.item.user.information.fullname }}
            </template>
            <template #cell(bending)="row">
              <span class="mr-15">
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[0].bending + " 度"
                    : ""
                }}
              </span>
              <span>
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[0].bending_point + " 点"
                    : ""
                }}
              </span>
            </template>
            <template #cell(bendingFirst)="row">
              <span class="mr-15">
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[0].abduction + " 度 "
                    : ""
                }}
              </span>
              <span>
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[0].abduction_point + " 点"
                    : ""
                }}
              </span>
            </template>
            <template #cell(abduction)="row">
              <span class="mr-15">
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[1].bending + " 度 "
                    : ""
                }}
              </span>
              <span>
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[1].bending_point + " 点"
                    : ""
                }}
              </span>
            </template>
            <template #cell(abductionFirst)="row">
              <span class="mr-15">
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[1].abduction + " 度 "
                    : ""
                }}
              </span>
              <span>
                {{
                  row.item.answer_video && row.item.answer_video.length > 0
                    ? row.item.answer_video[1].abduction_point + " 点"
                    : ""
                }}
              </span>
            </template>
            <template #cell(total)="row">
              {{
                row.item.answer_video && row.item.answer_video.length !== null
                  ? Math.round(((row.item.answer_video[1].bending_point + row.item.answer_video[1].abduction_point +
                    row.item.answer_video[0].abduction_point + row.item.answer_video[0].bending_point) / 4)) + " 点"
                  : ""
              }}
            </template>
            <template #cell(createdAt)="row">
              {{ row.item.created_at | fomatDate2 }}
            </template>
            <template #cell(urlVideo)="row">
              <ul class="list-inline font-size-18 contact-links mb-0">
                <li class="list-inline-item px-2" @click="
                  (urlVideo = row.item.video_hipscore_url),
                  (showVideo = true),
                  (dateTest = row.item.created_at)
                  ">
                  <a v-b-tooltip.hover title="詳細">
                    <i class="bx bxs-videos text-white bg-info p-1" style="border-radius: 50%; cursor: pointer"></i>
                  </a>
                </li>
              </ul>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-if="gRangerOfMotion.length === 0">
          <div class="undefine">
            <img src="@/assets/images/no-data.jpg" alt="" />
            <div class="mt-3">詳細データはありません。</div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-2 position-relative" v-if="gRangerOfMotion.length > 0">
          <div class="
            d-flex
            flex-column
            justify-content-center
            text-muted
            position-absolute
            h-100
            " style="left: 0; bottom: 0">
            <span class="text-muted">{{ gPaginationRangeOfMotion.total }}の{{
              gPaginationRangeOfMotion.from
            }}-{{ gPaginationRangeOfMotion.to }}を表示しています</span>
          </div>
          <div>
            <ul class="pagination pagination-rounded justify-content-center mt-4">
              <li class="page-item">
                <a :class="{ disabled: page === 1 }" href="javascript: void(0)"
                  @click="OnPagination(page > 1 ? page - 1 : 1)" class="page-link">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li v-for="n in paginationPages" :key="n" class="page-item" :class="n === page ? 'active' : ''">
                <a href="javascript: void(0)" @click="OnPagination(n)" class="page-link"
                  :class="n === page ? 'btn-lyg' : ''">{{
                  n }}</a>
              </li>
              <li class="page-item">
                <a :class="{ disabled: page === paginationPages }" href="javascript: void(0)" @click="
                  OnPagination(
                    page === paginationPages ? paginationPages : page + 1
                  )
                  " class="page-link">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
          <div></div>
        </div>
      </Loader>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import { filter } from "../../helpers/Vue-Filter";
import { rangeOfMotionMethod, rangeOfMotionComputed } from "@/state/helpers";
import Loader from "../../components/widgets/loader.vue";
import { mixin } from "../../helpers/Vue-Mixin";
import startVideo from "./startVideo.vue";
import api from "@/api/";
import moment from "moment";
// const Add = () => import(/* webpackChunkName: "Facility-Add" */ "./add.vue");
// const Edit = () => import(/* webpackChunkName: "Facility-Add" */ "./edit.vue");

export default {
  /* eslint-disable no-console */

  filters: {
    ...filter,
  },

  mixins: [mixin],

  page: {
    title: "可動域",
    meta: [{ name: "description", content: appConfig.description }],
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    time_out_facility: {
      type: String,
      required: false
    },
    userInfor: {
      require: true
    },
    isExpand: {
      type: Boolean,
    }
  },

  components: { Loader, startVideo },

  data() {
    return {
      items: [
        {
          text: "可動域",
          href: "/admin/range-of-motion",
          active: true,
        },
      ],

      filter: {},
      filterOn: [],
      sortBy: "age",
      sortDesc: false,

      dataInsert: {},
      dataUpdate: {},
      pagination: {
        current_page: 1,
        total: 20,
        per_page: 20,
      },
      loader: false,
      valueSelectStatus: null,
      valueSelectSex: null,
      page: 1,
      paginationPages: 5,
      isFlagShowModalAdd: false,
      isFlagShowModalEdit: false,

      urlVideo: "",
      showVideo: false,
      dateTest: null,

      isAll: false,
      ignoreIds: [],
      excelIds: [],
    };
  },

  created() {
    try {
      this.loader = true;
      this.getACountRangeOfMotion();
      this.fetchRangerOfMotion({
        user_id: this.userId,
        time_out_facility: this.time_out_facility,
      }).then((e) => {
        if (e.status === 200) {
          this.loader = false;
        }
      });
      this.pagination = Object.assign(this.gPaginationRangeOfMotion, {});
    } catch (error) {
      console.log(error);
    }
  },

  watch: {
    gPaginationRangeOfMotion: {
      handler(value) {
        this.pagination = Object.assign(value, {});
        this.paginationPages = value.last_page;
      },
      deep: true,
    },
  },

  computed: {
    ...rangeOfMotionComputed,

    fields() {
      return [
        { key: "#", class: "text-center align-middle p-3 tilte-column" },
        {
          key: "createdAt",
          label: "チェック日",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "bending",
          label: "左足屈曲",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "bendingFirst",
          label: "左足外転",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "abduction",
          label: "右足屈曲",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "abductionFirst",
          label: "右足外転",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "total",
          label: "可動域",
          class: "text-center align-middle p-3 tilte-column",
        },
        // {
        //   key: "urlVideo",
        //   label: "アップロードした動画",
        //   class: "text-center align-middle p-3 tilte-column",
        // },
      ];
    },
  },

  methods: {
    ...rangeOfMotionMethod,

    async onFilter() {
      this.getACountRangeOfMotion();
      await this.handlerSearch();
    },

    async handlerSearch(page = 1) {
      try {
        this.loader = true;
        this.page = page < 1 ? 1 : page;
        const payloadSearch = Object.assign({
          page: this.page,
          user_id: this.userId,
          time_out_facility: this.time_out_facility,
        }, this.filter);
        await this.fetchRangerOfMotion(payloadSearch).then((e) => {
          if (e.status === 200) {
            this.loader = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async handlerSubmit() {
      try {
        await this.post(this.dataInsert);
      } catch (error) {
        console.log(error);
      }
    },

    async OnPagination(page) {
      try {
        this.loader = true;
        await this.handlerSearch(page);
      } catch (error) {
        console.log(error);
      }
    },

    closeModal() { },

    showAdd() { },

    async handlerReject() {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to reject?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, reject it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const respon = await this.reject();
            if (respon.status === 200) {
              this.alertSuccess();
              this.fetchHospital();
            }
            if (respon.status !== 200) {
              this.alertError(respon.status);
              return;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    showModalEdit() { },

    chooseItem(id) {
      if (this.isAll) {
        this.ignoreIds = this.setArray(this.ignoreIds, id);
        if (this.ignoreIds.length === this.gPaginationRangeOfMotion.total) {
          this.isAll = false;
          this.ignoreIds = [];
        }
      } else {
        this.excelIds = this.setArray(this.excelIds, id);
        if (this.excelIds.length === this.gPaginationRangeOfMotion.total) {
          this.isAll = true;
          this.excelIds = [];
        }
      }
    },

    setArray(array, id) {
      const index = array ? array.findIndex((element) => element === id) : -1;
      index >= 0 ? array.splice(index, 1) : array.push(id);

      return array;
    },
    isChecked(id) {
      return (
        (this.isAll && !this.ignoreIds.includes(id)) ||
        this.excelIds.includes(id)
      );
    },

    isCheckedAll() {
      if (this.gRangerOfMotion.length > 0) {
        return (
          (this.isAll && this.ignoreIds.length === 0) ||
          this.excelIds.length === this.gPaginationRangeOfMotion.total
        );
      }

      return false;
    },

    checkAll() {
      if (this.ignoreIds.length > 0) {
        this.ignoreIds = [];
      } else {
        this.isAll = !this.isAll;
        if (!this.isAll) {
          this.excelIds = [];
        }
      }
    },

    activeExport() {
      if (this.gRangerOfMotion.length > 0) {
        return !this.isAll && this.excelIds.length === 0;
      }

      return true;
    },

    async doAction() {
      if (!this.isAll && this.excelIds.length === 0) {
        window.toastr.error("可動域評価を選択してください");
      } else {
        try {
          let payload = {
            user_id: this.userId,
            time_out_facility: this.time_out_facility,
          };
          if (this.isAll) {
            if (
              this.filter.username !== undefined &&
              this.filter.username !== ""
            ) {
              payload.username = this.filter.username;
            }
            if (
              this.filter.name !== undefined &&
              this.filter.name !== ""
            ) {
              payload.name = this.filter.name;
            }

            if (this.ignoreIds.length > 0) {
              payload.ignore_ids = this.ignoreIds.toString();
            }
          } else {
            payload.ids = this.excelIds.toString();
          }
          const formattedDate = moment().format('YYYYMMDD');
          api.exportExcelRangeOfMotion(payload, `可動域評価_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`);
          this.initExport();
        } catch (error) {
          console.log(error);
        }
      }
    },
    initExport() {
      this.isAll = false;
      this.ignoreIds = [];
      this.excelIds = [];
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}

.bg-icon {
  background: #8fc31f;
}

.bg-disabled {
  border: 1px solid #d3d3d3 !important;
  border-radius: 4px;
  background: #ffffff !important;
  color: #d3d3d3 !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::v-deep .position-relative {
  position: unset;
}

::v-deep .b-table-sticky-header {
  max-height: 38vh;
  overflow: auto !important;
}

::v-deep td.tilte-column {
  color: #404040 !important;
  font-weight: 400 !important;
  font-size: 14px;
}

::v-deep table {
  border-top: 0 !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}

.mr-15 {
  margin-right: 15px;
}
</style>
